import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';
import HomeHero from './components/HomeHero';
import FeaturedArticle from './components/FeaturedArticle';
import HotTopicsGrid from './components/HotTopicsGrid';
import CategoryGrid from './components/CategoryGrid';
import SubscribeCTA from './components/SubscribeCTA';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '91在线吃瓜',
      url: 'https://91onlinechigua.com',
      description: '91在线吃瓜网汇集全网最新网红爆料、明星黑料与热门追踪资讯，每日更新，吃瓜群众首选入口。',
      logo: 'https://91onlinechigua.com/logo.png',
    },
    {
      '@type': 'WebSite',
      name: '91在线吃瓜',
      url: 'https://91onlinechigua.com',
      description: '91在线吃瓜网汇集全网最新网红爆料、明星黑料与热门追踪资讯，每日更新，吃瓜群众首选入口。',
    },
    {
      '@type': 'WebPage',
      name: '91在线吃瓜 - 首页',
      url: 'https://91onlinechigua.com',
      description: '91在线吃瓜网汇集91在线吃瓜黑料官网入口与最新地址，每日更新网红黑料吃瓜视频，在线观看不迷路，热门爆料实时追踪。',
      isPartOf: { '@id': 'https://91onlinechigua.com/#website' },
      about: { '@id': 'https://91onlinechigua.com/#organization' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '91在线吃瓜网是什么？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '91在线吃瓜网是一个汇集网红爆料、明星黑料、热门追踪等最新吃瓜资讯的娱乐平台。每日更新，涵盖抖音、快手、B站、小红书、视频号等全平台内容。',
          },
        },
        {
          '@type': 'Question',
          name: '如何找到91在线吃瓜的最新地址？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '91在线吃瓜网的最新入口地址为官方网站首页。您可以通过搜索引擎搜索"91在线吃瓜"找到我们，或收藏我们的官网地址以便随时访问。',
          },
        },
        {
          '@type': 'Question',
          name: '91在线吃瓜网每天更新多少内容？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '91在线吃瓜网每日更新50条以上最新爆料内容，涵盖网红圈、娱乐圈、直播圈等多个领域，确保吃瓜群众不遗漏任何一个热门事件。',
          },
        },
        {
          '@type': 'Question',
          name: '91在线吃瓜网的内容来源可靠吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '91在线吃瓜网的内容来源于各大社交平台、官方公告、媒体报道以及前线吃瓜群众的一手投稿，编辑团队会对信息进行多方核实后再行发布。',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEOHead
        title="91在线吃瓜 91在线吃瓜网 - 91在线吃瓜黑料官网入口与最新地址 | 每日网红黑料吃瓜视频在线观看不迷路"
        description="91在线吃瓜网汇集91在线吃瓜黑料官网入口与最新地址，每日更新网红黑料吃瓜视频，在线观看不迷路，热门爆料实时追踪，吃瓜群众首选入口。"
        keywords="91在线吃瓜网,91在线吃瓜黑料,91在线吃瓜官网,91在线吃瓜入口,91在线吃瓜最新地址,在线吃瓜,黑料吃瓜,网红爆料,吃瓜视频,每日更新"
        canonicalUrl="https://91onlinechigua.com"
        ogType="website"
        jsonLd={homeJsonLd}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <HomeHero />
            <FeaturedArticle />
            <HotTopicsGrid />
            <CategoryGrid />
            <SubscribeCTA />
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}